import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

type PrintStore = {
  products: number[]
  printTemplateId: string | number | null
  addProduct: (id: number) => void
  removeParticularProduct: (id: number) => void
  clearProducts: () => void
  changeProductOrdering: (ids: number[]) => void
  setProducts: (products: number[]) => void
  setPrintTemplateId: (printTemplateId: string | number | null) => void
}

const usePrintStore = create<PrintStore>()(
  devtools(
    persist(
      (set) => ({
        products: [],
        printTemplateId: null,
        // addProject: add id to products array if not duplicate
        //update on April 08, 2024: add id even if its duplicate
        addProduct: (id) =>
          set((state) => {
            return { products: [...state.products, id] }
          }),
        removeParticularProduct: (currentIndex) =>
          set((state) => ({
            products: state.products.filter(
              (productId, index) => index !== currentIndex
            ),
          })),
        clearProducts: () => set({ products: [] }),
        changeProductOrdering: (ids) => set({ products: ids }),
        setProducts: (products) =>
          set((state) => ({
            products,
          })),
        setPrintTemplateId: (id) =>
          set(() => ({
            printTemplateId: id,
          })),
      }),
      { name: 'print-storage' }
    )
  )
)

export default usePrintStore
